import { render, staticRenderFns } from "./HeaderInquiries2.vue?vue&type=template&id=361bac61&scoped=true&"
import script from "./HeaderInquiries2.vue?vue&type=script&lang=js&"
export * from "./HeaderInquiries2.vue?vue&type=script&lang=js&"
import style0 from "./HeaderInquiries2.vue?vue&type=style&index=0&id=361bac61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361bac61",
  null
  
)

export default component.exports